import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Plus } from 'assets/svg/icon-plus.svg'

function IconPlus(props: IconProps): JSX.Element {
  const title = 'icon-plus'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Plus {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconPlus
